import React from 'react';
import styled, { css } from 'styled-components';
import type { SkeletonFlightInfo } from './types';
import SkeletonDetailsItem from './components/SkeletonDetailsItem';

type Props = {
  isMobile: boolean;
  to: SkeletonFlightInfo;
  back: SkeletonFlightInfo;
  className?: string;
};

const SkeletonDetails = ({ to, back, isMobile, className }: Props) => (
  <Wrapper $isMobile={isMobile} className={className}>
    <SkeletonDetailsItem item={to} isMobile={isMobile} direction="to" />
    <Divider $isMobile={isMobile} />
    <SkeletonDetailsItem item={back} isMobile={isMobile} direction="back" />
  </Wrapper>
);

const Wrapper = styled.div<{ $isMobile: boolean }>`
  flex: 1;
  ${(props) => (props.$isMobile ? '' : 'margin-top: 13px;')}

  ${(props) =>
    props.$isMobile &&
    css`
      padding: 8px 4px;
    `}
`;

const Divider = styled.hr<{ $isMobile: boolean }>`
  background: #e6e9ee;
  height: 1px;
  border: none;

  ${(props) =>
    props.$isMobile
      ? css`
          margin: 8px 4px;
        `
      : css`
          margin: 25px 8px 25px 21px;
        `}
`;

export default SkeletonDetails;
